import * as io from 'socket.io-client';
import { ITimeoutService } from 'angular';
import { environment } from '../../../../environments/environment';
import { noop } from 'lodash-es';

export class WebsocketService {
  static $inject = [
    '$timeout'
  ];

  private socket: SocketIOClient.Socket;

  constructor( private $timeout: ITimeoutService ) {
  }

  connect( token: string ) {
    // this.disconnect();
    this.socket = io(environment.host, { query: `auth_token=${token}` });
  }

  disconnect() {
    if ( this.socket ) {
      this.socket.close();
    }
  }

  on( eventName: string, cb: any ) {
    const socketCb = ( ...args ) => {
      this.$timeout(() => {
        cb(...args);
      });
    };
    this.socket.on(eventName, socketCb);
    return {
      off: () => this.socket.off(eventName, socketCb)
    };
  }

  emit( eventName: string, data: any = {}, cb = noop ) {
    this.socket.emit(eventName, data, ( ...args ) => {
      this.$timeout(() => {
        cb(...args);
      });
    });
  }

  off( eventName: string, cb ) {
    this.socket.off(eventName, ( ...args ) => {
      cb(...args);
    });
  }
}



// WEBPACK FOOTER //
// ./app/core/services/websocket/websocket.service.ts